/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestitle1Inputs */

const zh_learn_mistakestitle1 = /** @type {(inputs: Learn_Mistakestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错题本`)
};

const en_learn_mistakestitle1 = /** @type {(inputs: Learn_Mistakestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mistake Notebook`)
};

const es_learn_mistakestitle1 = /** @type {(inputs: Learn_Mistakestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuaderno de errores`)
};

/**
* | output |
* | --- |
* | "Mistake Notebook" |
*
* @param {Learn_Mistakestitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestitle1 = /** @type {((inputs?: Learn_Mistakestitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestitle1(inputs)
	if (locale === "en") return en_learn_mistakestitle1(inputs)
	return es_learn_mistakestitle1(inputs)
});
export { learn_mistakestitle1 as "learn_mistakesTitle" }